import { Body4, LocalTheme } from "@bale/ui";
import styled from "@emotion/styled";

export const ItemWrapper = styled.div<{
  isSelected?: boolean;
  isHighlighted?: boolean;
  disabled?: boolean;
}>`
  padding: 0 16px;
  background-color: ${({ theme, isSelected, isHighlighted, disabled }) =>
    isSelected || isHighlighted
      ? (theme as LocalTheme).colors.light[20]
      : (theme as LocalTheme).colors.light[50]};
  background-color: ${({ theme, disabled }) =>
    disabled ? `${(theme as LocalTheme).colors.light[10]}` : "white"};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => (theme as LocalTheme).colors.light[20]};
  }
`;
export const Item = styled(Body4)<{
  isPreview?: boolean;
  isPlaceholder?: boolean;
  disabled?: boolean;
  hasWarning?: boolean;
}>`
  max-width: ${({ isPreview }) => (isPreview ? "270px" : "100%")};
  flex-grow: 1;
  padding: ${({ isPreview }) => (!isPreview ? `12px 0` : `0`)};
  text-align: initial;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  justify-content: space-between;
  direction: rtl;
  color: ${({ isPlaceholder, disabled, hasWarning, theme }) =>
    isPlaceholder || disabled
      ? (theme as LocalTheme).colors.dark[100]
      : hasWarning
        ? (theme as LocalTheme).colors.alternative[2]
        : (theme as LocalTheme).colors.dark[500]};
  border-bottom: ${({ theme, isPreview }) =>
    !isPreview && `1px solid ${(theme as LocalTheme).colors.light[30]}`};
`;

export const ItemText = styled(Body4)<{
  isPreview: boolean;
  disabled?: boolean;
}>`
  margin: ${({ isPreview }) => (isPreview ? `0 auto 0 0` : `0 0 0 auto`)};
  display: inline-block;
  direction: ltr;
  color: ${({ disabled, theme }) =>
    disabled ? (theme as LocalTheme).colors.dark[100] : "#091E42"};
`;

export const ItemLabel = styled.span`
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: ltr;
  padding: 0 1rem 0 0;
  white-space: nowrap;
`;

export const DropdownList = styled.div`
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px #091e4226;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  direction: ltr;
  top: 100%;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
  }

  &::-webkit-scrollbar-thumb:vertical {
    min-height: 60px;
  }

  &::-webkit-scrollbar-thumb:horizontal {
    min-width: 60px;
  }
`;
export const Input = styled.input`
  font-family: Shabnam;
  background-color: transparent;
  outline: none;
  border: none;
  width: 100%;
  height: 100%;

  &:focus::placeholder {
    color: transparent;
  }
`;
